var transition = {"enter":"transition_enter__3eFAn","enterActive":"transition_enterActive__1i5rP","leave":"transition_leave__2mcaw","leaveActive":"transition_leaveActive__3KerM"};

export default transition;
